import { render, staticRenderFns } from "./layoutForm.vue?vue&type=template&id=787bc88a"
import script from "./layoutForm.vue?vue&type=script&lang=js"
export * from "./layoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports